import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormHexagon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconFormHexagon"><Path d="M10.75 2.14451C11.5235 1.69792 12.4765 1.69792 13.25 2.14451L19.9102 5.98923C20.6835 6.43575 21.16 7.26127 21.1602 8.15427V15.8457C21.16 16.7387 20.6835 17.5642 19.9102 18.0107L13.25 21.8554C12.4765 22.302 11.5235 22.302 10.75 21.8554L4.08984 18.0107C3.31646 17.5642 2.84 16.7387 2.83984 15.8457V8.15427C2.83999 7.26127 3.31646 6.43575 4.08984 5.98923L10.75 2.14451Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormHexagon;
